(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-fcd-root]');
  if (!root) return;

  var panel = root.querySelector('[data-fcd-panel]');
  var backdrop = root.querySelector('[data-fcd-backdrop]');
  var closeBtn = root.querySelector('[data-fcd-close]');
  var content = root.querySelector('[data-fcd-content]');
  var countEl = root.querySelector('[data-fcd-count]');
  var sectionId = root.getAttribute('data-fcd-section-id') || '';
  var lastFocused = null;

  function focusableEls() {
    return Array.prototype.slice.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
    );
  }

  function isOpen() {
    return root.classList.contains('is-open');
  }

  function openDrawer() {
    if (isOpen()) return;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function sectionUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function refreshDrawer() {
    if (!sectionId) return Promise.resolve();
    root.setAttribute('data-fcd-busy', 'true');
    return fetch(sectionUrl(), { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart drawer refresh failed');
        return res.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newContent = parsed.querySelector('[data-fcd-content]');
        var newCount = parsed.querySelector('[data-fcd-count]');
        if (newContent && content) content.innerHTML = newContent.innerHTML;
        if (newCount && countEl) countEl.textContent = newCount.textContent;
      })
      .catch(function () {
        // Real cart state still lives at /cart even if this refresh failed.
      })
      .finally(function () {
        root.removeAttribute('data-fcd-busy');
      });
  }

  // Anything on the site that successfully adds to cart dispatches this.
  document.addEventListener('cart:refresh', function () {
    refreshDrawer().then(openDrawer);
  });

  // Intercept the header's cart link (and any other /cart link) to open
  // the drawer instead of navigating, without touching the header file.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (link && !link.hasAttribute('data-fcd-allow-navigation')) {
      var linkUrl;
      try { linkUrl = new URL(link.href, window.location.href); } catch (err) { linkUrl = null; }
      if (linkUrl && /^\/(cart)\/?$/.test(linkUrl.pathname)) {
        e.preventDefault();
        refreshDrawer().then(openDrawer);
        return;
      }
    }

    if (e.target.closest('[data-fcd-close]') || e.target === backdrop) {
      closeDrawer();
      return;
    }

    var decBtn = e.target.closest('[data-fcd-qty-decrease]');
    var incBtn = e.target.closest('[data-fcd-qty-increase]');
    var removeBtn = e.target.closest('[data-fcd-remove]');

    if (decBtn || incBtn) {
      var line = (decBtn || incBtn).closest('[data-fcd-line]');
      if (!line || root.hasAttribute('data-fcd-busy')) return;
      var key = line.getAttribute('data-fcd-line-key');
      var qtyEl = line.querySelector('[data-fcd-qty-value]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      var next = incBtn ? current + 1 : current - 1;
      if (next < 0) next = 0;
      changeLine(key, next);
      return;
    }

    if (removeBtn) {
      var removeLine = removeBtn.closest('[data-fcd-line]');
      if (!removeLine || root.hasAttribute('data-fcd-busy')) return;
      changeLine(removeLine.getAttribute('data-fcd-line-key'), 0);
    }
  });

  function changeLine(key, quantity) {
    if (!key) return;
    root.setAttribute('data-fcd-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart change failed');
        return res.json();
      })
      .then(function () {
        return refreshDrawer();
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      var els = focusableEls();
      if (els.length === 0) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-shoppable"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.sa-size');
    if (sizeBtn && !sizeBtn.classList.contains('is-soldout')) {
      var card = sizeBtn.closest('[data-sa-card]');
      if (!card) return;

      card.querySelectorAll('.sa-size').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      sizeBtn.classList.add('is-selected');

      var variantId = sizeBtn.getAttribute('data-sa-variant-id');
      var hiddenInput = card.querySelector('[data-sa-variant-input]');
      if (hiddenInput) {
        hiddenInput.value = variantId;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var price = sizeBtn.getAttribute('data-sa-price');
      var compare = sizeBtn.getAttribute('data-sa-compare');
      var priceWrap = card.querySelector('[data-sa-price-display]');
      if (priceWrap && price) {
        var format = function (cents) {
          if (window.Shopify && Shopify.formatMoney && window.shopMoneyFormat) {
            return Shopify.formatMoney(cents, window.shopMoneyFormat);
          }
          return '£' + (cents / 100).toFixed(2);
        };
        var nowEl = priceWrap.querySelector('.sa-price-now');
        var wasEl = priceWrap.querySelector('.sa-price-was');
        if (nowEl) nowEl.textContent = format(price);
        if (compare && parseInt(compare, 10) > parseInt(price, 10)) {
          if (!wasEl) {
            wasEl = document.createElement('span');
            wasEl.className = 'sa-price-was';
            priceWrap.appendChild(wasEl);
          }
          wasEl.textContent = format(compare);
        } else if (wasEl) {
          wasEl.remove();
        }
      }
      return;
    }

    var showMoreBtn = e.target.closest('[data-sa-show-more]');
    if (showMoreBtn) {
      var stack = showMoreBtn.closest('.sa-card-stack');
      if (stack) {
        stack.querySelectorAll('.sa-product-card--collapsed').forEach(function (c) {
          c.classList.remove('sa-product-card--collapsed');
        });
      }
      showMoreBtn.remove();
      return;
    }

    var copyBtn = e.target.closest('[data-sa-copy]');
    if (copyBtn) {
      var url = copyBtn.getAttribute('data-sa-copy');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).catch(function () {});
      }
      var original = copyBtn.getAttribute('aria-label');
      copyBtn.setAttribute('aria-label', 'Link copied');
      setTimeout(function () { copyBtn.setAttribute('aria-label', original); }, 2000);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.sa-form');
    if (!form) return;
    e.preventDefault();

    var card = form.closest('[data-sa-card]');
    var msg = card ? card.querySelector('[data-sa-msg]') : null;
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function () {
        if (msg) {
          msg.textContent = 'Added to your cart.';
          msg.hidden = false;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function () {
        form.submit();
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-version1"] && !Shopify.designMode) return;
  try {
    
(function () {
  var loadBtn = document.querySelector('[data-ba-load-more]');
  var grid = document.querySelector('[data-ba-grid]');
  if (!loadBtn || !grid) return;

  var sectionId = grid.getAttribute('data-ba-section-id') || '';

  loadBtn.addEventListener('click', function (event) {
    var nextUrl = loadBtn.getAttribute('href');
    if (!nextUrl) return;
    event.preventDefault();

    var separator = nextUrl.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    loadBtn.setAttribute('aria-busy', 'true');
    var originalLabel = loadBtn.textContent;
    loadBtn.textContent = 'Loading…';

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load more articles');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = parsed.querySelector('[data-ba-grid]');
        var newLoadBtn = parsed.querySelector('[data-ba-load-more]');

        if (newGrid) {
          while (newGrid.firstChild) {
            grid.appendChild(newGrid.firstChild);
          }
        }

        loadBtn.removeAttribute('aria-busy');
        if (newLoadBtn && newLoadBtn.getAttribute('href')) {
          loadBtn.setAttribute('href', newLoadBtn.getAttribute('href'));
          loadBtn.textContent = originalLabel;
        } else {
          loadBtn.parentNode.removeChild(loadBtn);
        }
      })
      .catch(function () {
        window.location.href = nextUrl;
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
